import { Button } from '@mantine/core';
import { ButtonProps } from '@mantine/core';

interface SubscribeNowButtonProps extends ButtonProps {
    onClick: () => void;
    loading?: boolean;
}

export const SubscribeNowButton = ({ onClick, loading, ...props }: SubscribeNowButtonProps) => (
    <Button 
        size="lg" 
        loading={loading}
        onClick={onClick}
        {...props}
    >
        Subscribe Now
    </Button>
);